
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M8.5 1.5v14m4.208-12H6.771a2.93 2.93 0 0 0-1.96.732C4.292 4.702 4 5.337 4 6s.292 1.299.812 1.768A2.93 2.93 0 0 0 6.77 8.5h3.958c.735 0 1.44.263 1.96.732.52.47.811 1.105.811 1.768s-.292 1.299-.812 1.768a2.93 2.93 0 0 1-1.959.732H4"}})])
          )
        }
      }
    